import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../layouts';
import configBase from '../../../../configBase';
import axios from 'axios';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from "date-fns/locale/pt-BR";
import moment from 'moment';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Chip from '@material-ui/core/Chip';
import Switch from '@material-ui/core/Switch';
import Alert from '@material-ui/lab/Alert';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';


class CupomDesconto extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      nome: {value: '', required: true, error: '', type: 'text'},
      valor: {value: '', required: true, error: '', type: 'text'},
      tipoValor: {value: 'REAL', required: true, error: '', type: 'text'},
      dataInicial: {value: null, required: true, error: '', type: 'date'},
      dataFinal: {value: null, required: true, error: '', type: 'date'},
      tipoDesconto: {value: 'null', required: true, error: '', type: 'text'},
      status: {value: true, required: true, error: '', type: 'text'},
      planos: {value: [], required: true, error: '', type: 'text'},
      planosList: [],
      disabledDataFinal: true,
      editCupom: false,
      objEditPlan: null,
      errorRequest: false,
      msgErrorRequest: '',
      successRequest: false,
      msgSuccessRequest: '',
      loadingSave: false,
      cupomId: '',
    };

  }

  componentDidMount() {
    let search = this.props.history.location.search;

    axios.get(configBase.api + 'Plans/getPlansAll?access_token='+localStorage.getItem('planos_t'))
    .then((response) => {
      let state = this.state;
      state.planosList = response.data.sort(this.compareNamePlan);
      this.setState(state);

      // É uma edição
      if (search.length > 0) {
        let cupom = this.props.history.location.search.replace('?cpd=', '');

        if (cupom && cupom.length > 0 && search.indexOf('?cpd=') > -1) {
          axios.get(`${configBase.api}Cupons/${cupom}?access_token=${localStorage.getItem('planos_t')}`)
          .then((response2) => {
            let state = this.state;
            state.cupomId = cupom;
            state.objEditPlan = response2.data;
            state.disabledDataFinal = false;
            state.editCupom = true;
            state.nome.value = response2.data.nome;
            state.valor.value = response2.data.valor;
            state.dataInicial.value = moment(response2.data.dataInicial).format('YYYY-MM-DD');
            state.dataFinal.value = moment(response2.data.dataFinal).format('YYYY-MM-DD');
            state.planos.value = this.formatPlansToEdit(response2.data.planos, response.data.sort(this.compareNamePlan));
            state.status.value = response2.data.status;
            state.tipoDesconto.value = response2.data.tipoDesconto;
            state.tipoValor.value = response2.data.tipoValor;
            this.setState(state);
          })
          .catch(function () {
            this.setError('Problema encontrado ao buscar dados da cupom');
          }.bind(this));
        }
        else {
          state.editCupom = false;
          this.setError('O cupom não foi identificado corretamente');
        }
      }
      // Não é uma edição
      else
        state.editCupom = false;

      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar cupom');
    }.bind(this));
  }

  updateFields(event) {
    let state = this.state;

    /* if (event.target.name === 'nome')
      state[event.target.name].value = event.target.value.toUpperCase();
    else
      state[event.target.name].value = event.target.value; */

    state[event.target.name].value = event.target.value;

    state[event.target.name].error = '';
    this.setState(state);
  }

  updateFieldDate(field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    state[field].error = '';
    this.setState(state);

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      if (value.getTime() !== 0) {
        day = value.getDate();
        month = value.getMonth() + 1;
        year = value.getFullYear();;

        if (day < 10)
          day = '0'+ day;
        if (month < 10)
          month = '0'+ month;

        state[field].value = year+'-'+month+'-'+day;
        this.setState(state);

        this.validateDate(day+'/'+month+'/'+year, field);
      }
      else {
        state[field].value = value;
        state[field].error = 'Data inválida';
        this.setDisabledDataFinal(field, true);
      }
    }
    else {
      state[field].value = value;
      state[field].error = 'Data inválida';
      this.setDisabledDataFinal(field, true);
    }

    this.setState(state);
  }

  validateDate(date, field) {
    let dateReg = /^((((0?[1-9]|[12]\d|3[01])[.\-/](0?[13578]|1[02])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[.\-/](0?[13456789]|1[012])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|(29[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    if (date.length > 0) {
      // Caso não tenha passado no teste
      if (!dateReg.test(date)) {
        let state = this.state;
        state[field].error = 'Data inválida';
        this.setState(state);

        this.setDisabledDataFinal(field, true);
      }
      // Caso passe no teste
      else {
        this.setDisabledDataFinal(field, false);
        // 
        if (field === 'dataFinal') {
          let initial = moment(this.state.dataInicial.value.replace('/', '-').replace('/', '-'));
          let final = moment(this.state.dataFinal.value.replace('/', '-').replace('/', '-'));

          if (final.diff(initial, 'days') < 0) {
            let state = this.state;
            state.dataFinal.error = 'Data Fim deve ser maior ou igual que a inicial';
            this.setState(state);
          }
        }
      }
    }
  }

  setDisabledDataFinal(field, disabled) {
    if (field === 'dataInicial') {
      let state = this.state;
      state.disabledDataFinal = disabled;
      this.setState(state);
    }
  }

  updateCurrencyd(event, value) {
    let state = this.state;
    state[event.target.name].value = value;
    state[event.target.name].error = '';
    this.setState(state);
  }

  updatePercentage(event) {
    let state = this.state;
    state[event.target.name].value = event.target.value.replace(/[^\d]+/g,"");

    if (state[event.target.name].value > 100)
      state[event.target.name].error = 'Máximo permitido: 100%';
    else
      state[event.target.name].error = '';

    this.setState(state);
  }

  handleChange(event) {
    let listTemp = [];
    let list = [];

    for (let i = 0; i < event.target.value.length; i++) {
      listTemp.push(event.target.value[i].id);
    }

    for (let i = 0; i < event.target.value.length; i++) {
      if (listTemp.filter(x => x === event.target.value[i].id).length <= 1) {
        list.push(event.target.value[i]);
      }
    }

    let state = this.state;
    state[event.target.name].value = list;
    state[event.target.name].error = '';
    this.setState(state);
  }

  plansRenderValue(value) {
    let result = [];

    for (let i = 0; i < value.length; i++) {
      result.push(value[i].name);
    }

    return (
      <div style={{display: 'flex', flexWrap: 'wrap'}}>
        {result.map((value) => (
          <Chip key={value} label={value} style={{margin: 2}} />
        ))}
      </div>
    );
  }

  compareNamePlan(a, b) {
    let aPlan = a.name;
    let bPlan = b.name;

    if (aPlan > bPlan)
      return 1;
    if (aPlan < bPlan)
      return -1;
    return 0;
  }

  typeDashboardChange(event) {
    let state = this.state;
    state.status.value = event.target.checked;
    this.setState(state);
  }

  checkField() {
    let fields = ['nome', 'tipoValor', 'dataInicial', 'dataFinal', 'tipoDesconto'];
    let state = this.state;
    let error = false;
    state.loadingSave = true;
    this.setState(state);

    for (let i = 0; i < fields.length; i++) {
      if (state[fields[i]].error.length === 0) {
        // Para campos diferente do tipo data
        if (state[fields[i]].value != null) {
          if (state[fields[i]].required === true && state[fields[i]].value.replace('null', '').length === 0) {
            error = true;
            state[fields[i]].error = 'Campo obrigatório';
          }
          else
            state[fields[i]].error = '';
        }
        // Para campos do tipo data
        else {
          if (state[fields[i]].required === true) {
            error = true;
            state[fields[i]].error = 'Campo obrigatório';
          }
          else
            state[fields[i]].error = '';
        }
      }
      else
        error = true;
    }

    // Verifica o campo planos
    if (state.planos.value.length === 0) {
      error = true;
      state.planos.error = 'Campo obrigatório';
    }

    // Verifica o campo valor
    if (state.valor.value.replace(/[^0-9]/g, '').length === 0 || parseFloat(state.valor.value.replace(/[^0-9]/g, '')) === 0) {
      error = true;
      state.valor.error = 'Campo obrigatório';
    }

    this.setState(state);

    if (error === false) {
      if (this.state.editCupom === true)
        this.saveEditPlans();
      else
        this.savePlans();
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  savePlans() {
    if (this.state.nome.error.length === 0 &&
      this.state.valor.error.length === 0 &&
      this.state.tipoValor.error.length === 0 &&
      this.state.dataInicial.error.length === 0 &&
      this.state.dataFinal.error.length === 0 &&
      this.state.tipoDesconto.error.length === 0 &&
      this.state.status.error.length === 0 &&
      this.state.planos.error.length === 0) {
    
      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        nome: this.state.nome.value,
        valor: this.state.valor.value,
        tipoValor: this.state.tipoValor.value,
        dataInicial: moment(this.state.dataInicial.value.replace('/', '-').replace('/', '-')).format('YYYY-MM-DDT00:00:00.000Z'),
        dataFinal: moment(this.state.dataFinal.value.replace('/', '-').replace('/', '-')).format('YYYY-MM-DDT23:59:59.000Z'),
        tipoDesconto: this.state.tipoDesconto.value,
        status: this.state.status.value,
        planos: this.formatPlansToSave(),
      };
      
      axios.post(configBase.api + 'Cupons?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then(() => {
        this.stateDefault();
        this.setSuccess('Cupom salvo com sucesso');
      })
      .catch(function () {
        let state = this.state;
        state.loadingSave = false;
        this.setError('Problema encontrado ao salvar cupom');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  stateDefault() {
    let state = this.state;
    state.nome = {value: '', required: true, error: '', type: 'text'};
    state.valor = {value: '', required: true, error: '', type: 'text'};
    state.tipoValor = {value: 'REAL', required: true, error: '', type: 'text'};
    state.dataInicial = {value: null, required: true, error: '', type: 'date'};
    state.dataFinal = {value: null, required: true, error: '', type: 'date'};
    state.tipoDesconto = {value: 'null', required: true, error: '', type: 'text'};
    state.status = {value: true, required: true, error: '', type: 'text'};
    state.planos = {value: [], required: true, error: '', type: 'text'};
    state.loadingSave = false;
    this.setState(state);
  }

  formatPlansToSave() {
    let result = [];
    let plans = this.state.planos.value;

    for (let i = 0; i < plans.length; i++) {
      result.push(plans[i].id);
    }

    return result;
  }

  formatPlansToEdit(plans, planosList) {
    let result = [];

    for (let i = 0; i < planosList.length; i++) {
      for (let f = 0; f < plans.length; f++) {
        if (planosList[i].id === plans[f]) {
          result.push({
            id: planosList[i].id,
            name: planosList[i].name,
          });
        }
      }
    }

    return result;
  }

  saveEditPlans() {
    if (this.state.nome.error.length === 0 &&
      this.state.valor.error.length === 0 &&
      this.state.tipoValor.error.length === 0 &&
      this.state.dataInicial.error.length === 0 &&
      this.state.dataFinal.error.length === 0 &&
      this.state.tipoDesconto.error.length === 0 &&
      this.state.status.error.length === 0 &&
      this.state.planos.error.length === 0) {

      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        id: this.state.cupomId,
        nome: this.state.nome.value,
        valor: this.state.valor.value,
        tipoValor: this.state.tipoValor.value,
        dataInicial: moment(this.state.dataInicial.value.replace('/', '-').replace('/', '-')).format('YYYY-MM-DDT00:00:00.000Z'),
        dataFinal: moment(this.state.dataFinal.value.replace('/', '-').replace('/', '-')).format('YYYY-MM-DDT23:59:59.000Z'),
        tipoDesconto: this.state.tipoDesconto.value,
        status: this.state.status.value,
        planos: this.formatPlansToSave(),
      };

      let url = configBase.api + 'Cupons/upsertWithWhere?where={"id":"'+this.state.objEditPlan.id+'"}&access_token='+localStorage.getItem('planos_t');

      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        this.setSuccess('Cupom salvo com sucesso');
      })
      .catch(function () {
        let state = this.state;
        state.loadingSave = false;
        this.setError('Problema encontrado ao salvar cupom');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  planIndexOf(plan) {
    let result = false;

    for (let i = 0; i < this.state.planos.value.length; i++) {
      if (this.state.planos.value[i].id === plan.id) {
        result = true;
      }
    }

    return result;
  }

  backListCupom() {
    this.props.history.push(`${process.env.PUBLIC_URL}/cupomdesconto`);
  }

  verifyCupom () {
    axios.get(configBase.api + 'Cupons?filter={"where":{"nome":{"like":"'+
    this.state.nome.value+'", "options": "i"}},"fields":{"id":true}}&access_token='+localStorage.getItem('planos_t'))
    .then((response) => {
      let error = false;
      let state = this.state;

      if (response.data.length > 0) {
        // Para uma edição
        if (state.editCupom) {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].id.toString() !== state.cupomId.toString()) {
              error = true;
              break;
            }
          }
        }
        // Quando não for uma edição
        else
          error = true;
      }

      if (error)
        state.nome.error = 'Já existe um cupom com este nome';
      else
        state.nome.error = '';

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Problema encontrado ao salvar cupom');
    }.bind(this));
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  setSuccess(msg) {
    let state = this.state;
    state.successRequest = true;
    state.msgSuccessRequest = msg;
    this.setState(state);
  }

  successClose() {
    let state = this.state;
    state.successRequest = false;
    state.msgSuccessRequest = '';
    this.setState(state);
  }


  render() {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    return (
      <MainLayout history={this.props.history}>
        <div id="cupomdesconto" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  {
                    this.state.editCupom === true ? ('EDITAR CUPOM') : ('CADASTRAR CUPOM')
                  }
                </Typography>
              </Grid>

              <Grid item xs={12} sm={8} md={8} lg={8} className="botaoTituloAdd">
                <div className="botoesDeEnvio">
                  <Button
                    style={{fontSize: 11, backgroundColor: '#636d77', color: '#fff', marginRight: 5}}
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    size="small"
                    onClick={this.backListCupom.bind(this)}
                    color="default"
                  >
                    VOLTAR
                  </Button>
                </div>
                <div className="botoesDeEnvio containerButton">
                  <Button
                    variant="contained"
                    style={{fontSize: 11, backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<SaveIcon />}
                    size="small"
                    onClick={this.checkField.bind(this)}
                    disabled={
                      configBase.moduloCupomDesconto === true ? (this.state.loadingSave) : (true)
                    }
                  >
                    SALVAR
                  </Button>
                  {
                    this.state.loadingSave === true ? (
                  <CircularProgress size={24} className="progressButton" />
                    ) : ('')
                  }
                </div>
              </Grid>
            </Grid>
          </Paper>

          <div id="novocupomConteudo" className="contentepanel" style={{marginTop: 40}}>
            <Paper className="paperForm">
              <div className="paper">
                <Typography variant="h6" gutterBottom className="titlePaperForm">
                  Informações do Cupom
                </Typography>
              </div>

              <div>
                <Divider />
              </div>

              {
                configBase.moduloCupomDesconto === true ? (

              <div className="paper">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} className="containerButton">
                    <TextField
                      fullWidth
                      error={this.state.nome.error.length > 0 ? (true):(false)}
                      helperText={this.state.nome.error}
                      label={this.state.nome.required === true ? ("Nome *"):("Nome")}
                      type={this.state.nome.type}
                      variant="outlined"
                      size="small"
                      name="nome"
                      value={this.state.nome.value}
                      onChange={this.updateFields.bind(this)}
                      onBlur={this.verifyCupom.bind(this)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                      <KeyboardDatePicker
                        autoOk
                        fullWidth
                        error={this.state.dataInicial.error.length > 0 ? (true):(false)}
                        helperText={this.state.dataInicial.error}
                        variant="inline"
                        inputVariant="outlined"
                        label={this.state.dataInicial.required === true ? ("Data Início *"):("Data Início")}
                        format="dd/MM/yyyy"
                        size="small"
                        name="dataInicial"
                        value={
                          this.state.dataInicial.value === null ? (null) : (
                            this.state.dataInicial.value+'T00:00:00'
                          )
                        }
                        onChange={this.updateFieldDate.bind(this, 'dataInicial')}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                      <KeyboardDatePicker
                        autoOk
                        fullWidth
                        error={this.state.dataFinal.error.length > 0 ? (true):(false)}
                        helperText={this.state.dataFinal.error}
                        variant="inline"
                        inputVariant="outlined"
                        label={this.state.dataFinal.required === true ? ("Data Fim *"):("Data Fim")}
                        format="dd/MM/yyyy"
                        size="small"
                        name="dataFinal"
                        value={
                          this.state.dataFinal.value === null ? (null) : (
                            this.state.dataFinal.value+'T00:00:00'
                          )
                        }
                        onChange={this.updateFieldDate.bind(this, 'dataFinal')}
                        disabled={this.state.disabledDataFinal}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <TextField
                      fullWidth
                      select
                      error={this.state.tipoValor.error.length > 0 ? (true):(false)}
                      helperText={this.state.tipoValor.error}
                      label={this.state.tipoValor.required === true ? ("Formato Valor *"):("Formato Valor")}
                      variant="outlined"
                      size="small"
                      name="tipoValor"
                      SelectProps={{
                        native: true,
                      }}
                      value={this.state.tipoValor.value}
                      onChange={this.updateFields.bind(this)}
                    >
                      <option value="null">Selecione</option>
                      <option value="PORCENTAGEM">Porcentagem (%)</option>
                      <option value="REAL">Real (R$)</option>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                  {
                    this.state.tipoValor.value === 'REAL' ? (
                    <CurrencyTextField
                      fullWidth
                      error={this.state.valor.error.length > 0 ? (true):(false)}
                      helperText={this.state.valor.error}
                      label="Valor"
                      variant="outlined"
                      size="small"
                      value={this.state.valor.value.replace(',', '.')}
                      name="valor"
                      currencySymbol="R$"
                      outputFormat="string"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      onChange={this.updateCurrencyd.bind(this)}
                    />
                    ) : (
                    <TextField
                      fullWidth
                      error={this.state.valor.error.length > 0 ? (true):(false)}
                      helperText={this.state.valor.error}
                      label={this.state.valor.required === true ? ("Porcentagem *"):("Porcentagem")}
                      type={this.state.valor.type}
                      variant="outlined"
                      size="small"
                      name="valor"
                      value={this.state.valor.value}
                      onChange={this.updatePercentage.bind(this)}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                      }}
                    />
                    )
                  }
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <TextField
                      fullWidth
                      select
                      error={this.state.tipoDesconto.error.length > 0 ? (true):(false)}
                      helperText={this.state.tipoDesconto.error}
                      label={this.state.tipoDesconto.required === true ? ("Modalidade Desconto *"):("Modalidade Desconto")}
                      variant="outlined"
                      size="small"
                      name="tipoDesconto"
                      SelectProps={{
                        native: true,
                      }}
                      value={this.state.tipoDesconto.value}
                      onChange={this.updateFields.bind(this)}
                    >
                      <option value="null">Selecione</option>
                      <option value="ADESÃO">Adesão</option>
                      <option value="MENSAL">Mensalidade</option>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography component="div">
                      <Grid component="label" container alignItems="center" spacing={1}>
                        <Grid style={{lineHeight: '11px'}} item>Inativo</Grid>
                        <Grid item style={{padding: '4px 0px'}}>
                          <Switch checked={this.state.status.value} onChange={this.typeDashboardChange.bind(this)} />
                        </Grid>
                        <Grid style={{lineHeight: '11px'}} item>Ativo</Grid>
                      </Grid>
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl variant="outlined" size="small" fullWidth>
                      <InputLabel
                        id="demo-mutiple-checkbox-label"
                        style={{backgroundColor: '#fff', padding: '0px 5px', left: -5}}
                      >
                        Planos *
                      </InputLabel>
                      <Select
                        labelId="demo-mutiple-checkbox-label"
                        id="demo-mutiple-checkbox"
                        error={this.state.planos.error.length > 0 ? (true):(false)}
                        multiple
                        value={this.state.planos.value}
                        onChange={this.handleChange.bind(this)}
                        input={<OutlinedInput />}
                        renderValue={this.plansRenderValue.bind(this)}
                        MenuProps={MenuProps}
                        name="planos"
                      >
                        {this.state.planosList.map((plan) => (
                          <MenuItem key={plan.id} value={plan}>
                            {/* <Checkbox checked={this.state.planos.value.indexOf(plan) > -1} /> */}
                            <Checkbox checked={this.planIndexOf(plan) === true} />
                            <ListItemText primary={plan.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                </Grid>

              </div>
                ) : (
              <div className="paper">
                <Alert severity="error">Módulo de Cupom de Desconto não habilitado. Entre em contato com a Intelite Tecnologia</Alert>
              </div>
                )
              }
            </Paper>
          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.successClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSuccessRequest}
            </MuiAlert>
          </Snackbar>
        </div>
      </MainLayout>
    );

  }

}

CupomDesconto.propTypes = {
  history: PropTypes.object
};

export default withRouter(CupomDesconto);